import classNames from 'classnames';
import { lazy, Suspense, useCallback, useState } from 'react';

import CloseButton from '../buttons/CloseButton';
import Modal from './Modal';

import styles from '../../styles/popups/upload-modal.module.css';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/webcam/dist/style.min.css';

const UploadField = lazy(() => import('../fields/UploadField'));

type UploadModalProps = {
    className?: string;
    onCancel?: () => void;
    onComplete?: (Media) => void;
};

function UploadModal({ className = null, onCancel = null, onComplete = null }: UploadModalProps) {
    const [opened, setOpened] = useState(true);
    const onClickCancel = useCallback(() => {
        setOpened(false);
    }, [setOpened]);
    const onRequestClose = useCallback(() => {
        setOpened(false);
    }, [setOpened]);
    const onOpened = useCallback(() => {}, []);

    const [value, setValue] = useState(null);
    const onUploadChange = useCallback(
        (newFile) => {
            setValue(newFile);
            setOpened(false);
        },
        [onComplete],
    );

    const onClosed = useCallback(() => {
        console.log('ON CLOSED');
        if (value !== null && onComplete !== null) {
            onComplete(value);
        } else if (value === null && onCancel !== null) {
            onCancel();
        }
    }, [value, onCancel]);

    return (
        <Modal
            id="upload"
            opened={opened}
            withBackdrop
            withTransition
            // withScrollLock
            className={classNames([styles.container, className])}
            requestClose={onRequestClose}
            onClosed={onClosed}
            onOpened={onOpened}
        >
            <CloseButton onClick={onClickCancel} className={styles.closeButton} />
            <div className={styles.inner}>
                <Suspense fallback={null}>
                    <UploadField onChange={onUploadChange} />
                </Suspense>
            </div>
        </Modal>
    );
}

export default UploadModal;
